/* JV Furniture: smarter search. Shopify's own search stays in charge; this only steps in when a search finds no products.
   It then tries, in order: the query with spelling fixed and American/everyday words swapped for the shop's words,
   the query without its last word, and its longest word. The first attempt that finds products wins. */
(function () {
  'use strict';

  var VOCAB = ('bedside table tables bench benches blanket box boxes trunk trunks bookcase bookcases shelving shelf shelves cabinet cabinets ' +
    'chair chairs chest chests drawers drawer coffee console consoles dining dressing footstool footstools stool stools media unit units pet bed beds ' +
    'shoe storage side sideboard sideboards sofa sofas writing desk desks bar mirror lamp rug round oval square curved rounded fluted carved ' +
    'extendable foldable wall mounted open shelf castors oak walnut chestnut teak ash black white grey cream ivory brown gold golden charcoal ' +
    'natural cherry mocha honey caramel acacia sheesham mango reclaimed solid wood bouclé boucle leather tweed velvet linen rattan cane marble ' +
    'bone inlay metal glass cement cork tripod pineapple woven ribbed living room bedroom hallway office hall bedside nightstand dresser buffet ' +
    'console hexagonal rectangular storage drawers cupboard wardrobe sideboard display tallboy bookshelf').split(' ');
  var SET = {};
  VOCAB.forEach(function (w) {
    SET[w] = 1;
  });

  var SYN = [
    [/\bnight ?stands?\b/g, 'bedside table'],
    [/\bbed ?side (unit|cabinet|locker)s?\b/g, 'bedside table'],
    [/\bdressers?\b/g, 'chest of drawers'],
    [/\b(tv|television) (stands?|consoles?|cabinets?|benche?s?|units?)\b/g, 'tv unit'],
    [/\b(couch|couches|settee|settees)\b/g, 'sofa'],
    [/\b(ottomans?|poufs?|pouffes?|footrests?)\b/g, 'footstool'],
    [/\bentryway\b/g, 'hallway'],
    [/\bend tables?\b/g, 'side table'],
    [/\b(credenzas?|buffets?)\b/g, 'sideboard'],
    [/\b(book ?shel(f|ves)|shelving units?)\b/g, 'bookcase'],
    [/\bgray\b/g, 'grey'],
    [/\bcolor\b/g, 'colour']
  ];

  function dist(a, b) {
    var m = a.length;
    var n = b.length;
    var d = [];
    var i;
    var j;
    var c;
    for (i = 0; i <= m; i++) d[i] = [i];
    for (j = 1; j <= n; j++) d[0][j] = j;
    for (i = 1; i <= m; i++) {
      for (j = 1; j <= n; j++) {
        c = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
        d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + c);
        if (i > 1 && j > 1 && a.charAt(i - 1) === b.charAt(j - 2) && a.charAt(i - 2) === b.charAt(j - 1)) {
          d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
        }
      }
    }
    return d[m][n];
  }

  function fix(q) {
    var s = q.toLowerCase().replace(/\s+/g, ' ').trim();
    SYN.forEach(function (rule) {
      s = s.replace(rule[0], rule[1]);
    });
    return s
      .split(' ')
      .map(function (t) {
        if (t.length < 4 || SET[t] || !/^[a-z]+$/.test(t)) return t;
        if (VOCAB.some(function (w) {
          return w.indexOf(t) === 0;
        })) return t;
        var max = t.length >= 8 ? 2 : 1;
        var best = null;
        var bd = 99;
        for (var i = 0; i < VOCAB.length; i++) {
          var w = VOCAB[i];
          if (Math.abs(w.length - t.length) > max) continue;
          var x = dist(t, w);
          if (x < bd) {
            bd = x;
            best = w;
          }
        }
        return best && bd <= max ? best : t;
      })
      .join(' ');
  }

  function candidates(q) {
    var out = [];
    var base = q.toLowerCase().replace(/\s+/g, ' ').trim();
    var fixed = fix(q);
    var tokens = (fixed || base).split(' ').filter(Boolean);
    function add(x) {
      x = (x || '').trim();
      if (x && x !== base && out.indexOf(x) < 0) out.push(x);
    }
    add(fixed);
    if (tokens.length > 1) {
      add(tokens.slice(0, -1).join(' '));
      add(
        tokens.slice().sort(function (a, b) {
          return b.length - a.length;
        })[0]
      );
    }
    return out.slice(0, 3);
  }

  /* ---- The search box (predictive search) ---- */
  function hasProductCard(html) {
    try {
      return !!new DOMParser().parseFromString(html, 'text/html').querySelector('.predictive-search-results__card');
    } catch (e) {
      return true;
    }
  }

  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (!/\/search\/suggest/.test(url)) return nativeFetch.apply(this, arguments);
    var self = this;
    var args = arguments;
    return nativeFetch.apply(self, args).then(function (res) {
      var u;
      try {
        u = new URL(url, window.location.origin);
      } catch (e) {
        return res;
      }
      var q = (u.searchParams.get('q') || '').trim();
      if (!q || !res.ok) return res;
      return res
        .clone()
        .text()
        .then(function (html) {
          if (hasProductCard(html)) return res;
          var list = candidates(q);
          var i = 0;
          function next() {
            if (i >= list.length) return res;
            u.searchParams.set('q', list[i++]);
            return nativeFetch.call(self, u.toString(), init)
              .then(function (r) {
                return r.text().then(function (h) {
                  return hasProductCard(h) ? new Response(h, { status: 200, headers: { 'Content-Type': 'text/html' } }) : next();
                });
              })
              .catch(function () {
                return res;
              });
          }
          return next();
        })
        .catch(function () {
          return res;
        });
    });
  };

  /* ---- The search results page ---- */
  function showNote(orig, used) {
    var host = document.querySelector('results-list');
    if (!host || !host.parentNode) return;
    var note = document.createElement('p');
    note.className = 'jv-search-note';
    note.setAttribute('role', 'status');
    note.appendChild(document.createTextNode('No exact match for "' + orig + '", so these are the closest results for '));
    var strong = document.createElement('strong');
    strong.textContent = used;
    note.appendChild(strong);
    note.appendChild(document.createTextNode('.'));
    host.parentNode.insertBefore(note, host);
  }

  function searchPage() {
    if (window.location.pathname.replace(/\/$/, '') !== '/search') return;
    var params = new URLSearchParams(window.location.search);
    var q = (params.get('q') || '').trim();
    if (!q) return;
    var orig = params.get('jv_orig');
    if (orig) {
      showNote(orig, q);
      return;
    }
    var marker = document.querySelector('[data-jv-products]');
    if (marker && parseInt(marker.getAttribute('data-jv-products'), 10) > 0) return;

    var list = candidates(q);
    var i = 0;
    function next() {
      if (i >= list.length) return;
      var c = list[i++];
      var test = new URLSearchParams({ q: c, type: 'product' });
      nativeFetch('/search?' + test.toString(), { credentials: 'same-origin' })
        .then(function (r) {
          return r.text();
        })
        .then(function (html) {
          if (/data-jv-products="[1-9]/.test(html)) {
            params.set('q', c);
            params.set('jv_orig', q);
            window.location.replace('/search?' + params.toString());
          } else {
            next();
          }
        })
        .catch(function () {});
    }
    next();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', searchPage);
  else searchPage();
})();
